import url from "../../config/url";
import axios from "axios";
import _ from 'lodash';
import settings from "../../config/settings";

const state = {
    users: [],
    allocations: [],
    metadata: {},
    filter: {
        pageNumber: 1,
        pageSize: 30,
        previousMonthsCount: settings.previous_month_count,
        futureMonthsCount: settings.future_month_count,
        filterParams: [],
        sortColumn: null,
        sortOrder: null
    },
    result: [],
    noteData: {},
    oe_countries: [],

    // flags
    isFetchComplete: false,
    loader: false,
    showNotePopUp: false,
    loadingMoreRows: false, // to check if more data is fetching for forecast table
    globalLoader: false,
    globalUpdate: false,
    globalProgress: false,
    globalerrorSave: false,
    globalSuccessUnRelease:false
};
const mutations = {
    // set global loader
    setGlobalLoader: (state, value) => state.globalLoader = Object.freeze(value),
    // set forecast relation data into the state
    setForecastRelation: (state, value) => state.users = Object.freeze(value),
    // set the forecast allocation data
    setForecastAllocation: (state, value) => state.allocations = Object.freeze(value),
    // set the forecast metadata
    setForecastMetadata: (state, value) => state.metadata = Object.freeze(value),
    // set forecast result
    setForecastResult: (state, value) => state.result = Object.freeze(value),
    // set the loader value
    setForecastLoader: (state, value) => state.loader = value,

    setUpdateIcon:(state, value) => state.globalUpdate = Object.freeze(value),
    setprogressIcon:(state, value) => state.globalProgress = Object.freeze(value),
    seterrorSaveIcon:(state, value) => state.globalerrorSave = Object.freeze(value),
    setUnReleaseSuccessModel:(state, value) => state.globalSuccessUnRelease = Object.freeze(value),
    /**
     * Set the search value into the store
     * @param state
     * @param data
     */
    setSearchData: (state, data) => {
        // clone the filter
        let filter = _.cloneDeep(state.filter);
        // get the current filter by matching the field name
        let currentFilterObject = filter.filterParams.find(f => f.fieldName === data.key);
        // if the current filter already exists
        if (currentFilterObject) {
            // update the value if the new value is not null
            if (data.value) {
                currentFilterObject.value = data.value;
            } else {
                // remove the search entry if already exists and the value is null
                let index = filter.filterParams.indexOf(currentFilterObject);
                filter.filterParams.splice(index, 1);
            }
        } else {
            // if no filter object is find and the value is not null, create new object
            if (data.value) {
                let currentFilter = {
                    fieldName: data.key,
                    value: data.value
                };
                // push object into filter array
                filter.filterParams.push(currentFilter);
            }
        }
        // since the search will affect the whole rows, init the page number and search
        filter.pageNumber = 1;
        // set back the filter
        state.filter = Object.freeze(filter);
    },
    /**
     * Update relation engagement on updating the field
     * @param state
     * @param data :{id,value}
     */
    updateRelationEngagement: (state, data) => {
        // clone all the relations
        let users = _.cloneDeep(state.users);
        // set value to the assigned relation
        users[data.id] = data.value;
        // set the relation back
        state.users = Object.freeze(users);
        // cloning the value and updating is to track the change for watching from components
    },
    /**
     * Update allocation other value
     * @param state
     * @param data
     */
    updateAllocation: (state, data) => {
        // clone the allocation list
        let allocations = _.cloneDeep(state.allocations);
        // get the current month of allocation
        let allocation = allocations[data.allocationIndex];
        // loop through the values returned

        allocation.forecastMonthlyAllocations[data.id] = data.value;

        // todo: removed functionalities
        /*data.value.forEach((allocationRowData) => {
            // get the corresponding allocation row using relation id
            let row = allocation.forecastMonthlyAllocations.find(f => f.relationId === allocationRowData.relationId);
            // update the values
            row.totalSick = allocationRowData.totalSick;
            row.totalVacation = allocationRowData.totalVacation;
            row.other = allocationRowData.other;
            row.note = allocationRowData.note;
            row.forcastId = allocationRowData.forcastId;
        });*/
        // set the cloned value back to allocations
        state.allocations = Object.freeze(allocations);
    },
    /**
     * Increment page count
     * @param state
     */
    updateFilterPageCount: (state) => {
        // clone the filter value from store
        let filter = _.cloneDeep(state.filter);
        // update the page count
        filter.pageNumber++;
        // set the value back to store
        state.filter = filter;
    },
    /**
     * Update the forecast value on loading more data vertically
     * @param state
     * @param data
     */
    updateForecastData: function (state, data) {
        if (data && data.forecastRelations && data.forecastRelations.length > 0) {
            // get clones of existing forecast data
            let relation = _.cloneDeep(state.users);
            let allocation = _.cloneDeep(state.allocations);
            // merge relation data with the existing data
            state.users = [...relation, ...data.forecastRelations];
            // merge allocation data with the existing data
            // loop each allocation and get the allocation data by compating the index
            data.forecastMonthlyAllocations.forEach((monthlyAllocation, monthlyAllocationIndex) => {
                // merge the monthly allocation data into the existing data
                allocation[monthlyAllocationIndex].forecastMonthlyAllocations = [...allocation[monthlyAllocationIndex].forecastMonthlyAllocations, ...monthlyAllocation.forecastMonthlyAllocations];
            });
            // set allocation data into store value
            state.allocations = Object.freeze(allocation);
        } else {
            state.isFetchComplete = true;
        }
    },
    // set the popup flag value
    setNotePopUpFlag: (state, value) => state.showNotePopUp = value,
    // Set note data
    setNotePopUpData: (state, value) => state.noteData = value,
    // set the value to check if loading more rows for the forecast view
    setLoadingRowsStatus: (state, value) => state.loadingMoreRows = value,
    // set the sort data into filter
    setSort: (state, data) => {
        let filter = _.cloneDeep(state.filter);
        filter.sortColumn = data.column;
        filter.sortOrder = data.order
        state.filter = filter;
    },
    // set flag for completed status
    setCompleteStatus: (state, value) => {
        state.isFetchComplete = state.users.length >= value;
    },
    // set the country list
    setCountryList: (state, value) => state.oe_countries = value
};
const actions = {
    /**
     * Fetch forecast data
     * @param commit
     * @param state
     * @param filter
     * @returns {Promise<unknown>}
     */
    fetchForecast: function ({commit}, filter) {
        commit("setForecastLoader", true);
        commit("setGlobalLoader", true);
        return new Promise((resolve, reject) => {
            axios.post(url.forecast_api, filter)
                .then(
                    response => {
                        if (response.data.responseObject) {
                            commit("setForecastRelation", response.data.responseObject.forecastRelations);
                            commit("setForecastAllocation", response.data.responseObject.forecastMonthlyAllocations);
                            commit("setForecastMetadata", response.data.responseObject.metaData);
                            commit("setCompleteStatus", response.data.totalCount);
                            resolve(true);
                        } else {
                            reject(false);
                        }
                        commit("setForecastLoader", false);
                        commit("setGlobalLoader", false);
                    }
                )
                .catch(
                    reason => {
                        reject(reason);
                        commit("setForecastLoader", false);
                        commit("setGlobalLoader", false);
                    }
                )
        })
    },
    /**
     * Send the relation item to update
     * @param commit
     * @param data {id,value}
     * @param dispatch
     * @param state
     * @returns {Promise<unknown>}
     */
    updateRelation: function ({commit, state, dispatch}, data) {
        return new Promise(() => {
            axios.post(url.update_relation, data.value)
                .then(
                    response => {
                        if (response.data.status) {
                            // get the response object
                            data.value = response.data.responseObject;
                            // update the value in store
                            commit("updateRelationEngagement", data);
                            dispatch("fetchForecastResult", state.filter);
                        }
                    }
                )
        })
    },
    /**
     * Update the monthly allocation data
     * @param commit
     * @param data
     * @param dispatch
     * @param state
     * @returns {Promise<unknown>}
     */
    updateAllocation: function ({commit, state, dispatch}, data) {
        return new Promise((resolve) => {
            axios.post(url.update_allocation, data.value)
                .then(
                    response => {
                        if (response.data.status) {
                            // get the response object
                            data.value = response.data.responseObject;
                            // update the value in store
                            commit("updateAllocation", data);
                            resolve(true);
                            dispatch("fetchForecastResult", state.filter);
                        }
                    }
                )
        })
    },

    /**
     * Fetch more forecast data vertically
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     */
    fetchMoreForecast: function ({commit, state}) {
        // update the filter count
        commit("updateFilterPageCount");
        if (!state.isFetchComplete) {
            commit("setLoadingRowsStatus", true);
            // promise
            return new Promise((resolve, reject) => {
                // send request
                axios.post(url.forecast_api, state.filter)
                    .then(
                        response => {
                            // if response status is true
                            if (response.data.status) {
                                // update the existing forecast data
                                commit("setCompleteStatus", response.data.totalCount);
                                commit("updateForecastData", response.data.responseObject);
                                resolve(true);
                            } else {
                                reject(false);
                            }
                            commit("setLoadingRowsStatus", false);
                        }
                    )
                    .catch(
                        reason => {
                            reject(reason);
                            commit("setLoadingRowsStatus", false);
                        }
                    )
            })
        }
    },
    /**
     * Fetch the allocation total data
     * This will consider the current fitter applied not the pagination
     * @param commit
     * @param state
     * @returns {Promise<unknown>}
     */
    fetchForecastResult: function ({commit, state}) {
        return new Promise((resolve, reject) => {
            axios.post(url.allocation_result, state.filter)
                .then(
                    response => {
                        if (response.data.status) {
                            // set the data into store
                            commit("setForecastResult", response.data.responseObject);
                            resolve(response);
                        }
                    }
                ).catch(reason => reject(reason))
        });
    },
    /**
     * Get all country list
     * @param commit
     * @returns {Promise<unknown>}
     */
    fetchOECountryList: function ({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(url.oe_country_list_api)
                .then(
                    response => {
                        if (response.data.status) {
                            commit("setCountryList", response.data.responseObject);
                            resolve(response)
                        } else {
                            reject(response);
                        }
                    }
                )
        })
    }
};
export default {
    state,
    mutations,
    actions
}
